export const SET_PAYMENT_PLAN = "SET_PAYMENT_PLAN";
export const SET_OWING = "SET_OWING";
export const SET_INSTALLMENTS = "SET_INSTALLMENTS";
